import { Component, computed, inject, output } from '@angular/core';
import { User } from '../user.model';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { AppState } from 'src/app/app.state';
import { LoadingSpinnerComponent } from '../../../core/loading-spinner/loading-spinner.component';
import { UserRowComponent } from '../user-row/user-row.component';
import { UserListStateService } from '../users-overview/user-list.state.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';

@Component({
  selector: 'adm-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss'],
  imports: [LoadingSpinnerComponent, UserRowComponent, CommonModule, MatPaginatorModule, MatSortModule],
})
export class UsersListComponent {
  state = inject(UserListStateService);
  appState = inject(AppState);
  refreshAfterUpdateEvent = output<User>();
  refreshAfterDeleteEvent = output<User>();

  data = toSignal(this.state.users$, {
    initialValue: { items: [], totalCount: 0, pageIndex: 0, pageSize: this.state.defaultPageSize },
  });
  usersData = computed(() => this.data() ?? { items: [], totalCount: 0, pageIndex: 0, pageSize: this.state.defaultPageSize });
  public pageSwitch(event: PageEvent) {
    this.state.viewState.update(x => ({
      ...x,
      page: event,
    }));
  }
  public sortData(event: Sort) {
    this.state.viewState.update(x => ({
      ...x,
      sort: event,
      page: { ...x.page, pageIndex: 0 },
    }));
  }

  refreshAfterUpdate(user: User) {
    this.refreshAfterUpdateEvent.emit(user);
  }

  refreshAfterDelete(user: User) {
    this.refreshAfterDeleteEvent.emit(user);
  }
}
